module.exports = __webpack_public_path__ + "img/im.e70fe6e0.svg";